import { Icon } from "@iconify/react";
import React, { useState } from "react";
import { Link } from "react-router-dom";
import { blogData } from "../../data/blogs";
import Spacing from "../Spacing";

export default function BlogHero() {
  const [activeLink, setActiveLink] = useState(0);
  const handleIconHover = (index) => {
    setActiveLink(index);
  };
  return (
    <div className="cs_case_study_1_list" style={{ padding: "0px 40px" }}>
      {blogData.map((item, index) => (
        <div
          className={`cs_case_study cs_style_1 cs_hover_active ${
            index === activeLink ? "active" : ""
          }`}
          onMouseEnter={() => handleIconHover(index)}
          key={index}
        >
          <Link
            to={item.href}
            className="cs_case_study_thumb cs_bg_filed"
            style={{
              backgroundImage: `url(${item.thumbnailSrc})`,
            }}
          />
          <span className="cs_case_study_number cs_primary_font cs_accent_color cs_fs_38 cs_semibold position-absolute">
            {index + 1}
          </span>
          <span className="cs_case_study_icon cs_center rounded-circle position-absolute">
            <Icon icon="fa6-solid:arrow-right" />
          </span>
          <div className="cs_case_study_in">
            
            <h2 className="cs_case_study_title cs_fs_38 cs_white_color mb-0">
              <Link to={item.href}>{item.title}</Link>
            </h2>
            <Spacing lg="50" md="30" />
            <div className="cs_case_study_category cs_white_color cs_fs_18 cs_medium">
              <Link>{item.category}</Link>
            </div>
          </div>
        </div>
      ))}
    </div>
  );
}
